module.exports = __webpack_public_path__ + "static/media/Phenikaa_University.fe7fdde4.jpg";